"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbsoluteCharacteristicValueBaseSchema = void 0;
const zod_1 = require("zod");
const ISerializedProvenanceNode_1 = require("./ISerializedProvenanceNode");
exports.AbsoluteCharacteristicValueBaseSchema = zod_1.z.object({
    value: zod_1.z
        .number()
        .optional()
        .nullish()
        .transform((v) => v ?? undefined),
    allowableRange: zod_1.z.object({
        min: zod_1.z
            .number()
            .optional()
            .nullish()
            .transform((v) => v ?? undefined),
        max: zod_1.z
            .number()
            .optional()
            .nullish()
            .transform((v) => v ?? undefined),
    }),
    discreteValues: zod_1.z
        .object({
        value: zod_1.z.number(),
    })
        .array()
        .optional()
        .nullish()
        .transform((v) => v ?? undefined),
    provenance: ISerializedProvenanceNode_1.ISerializedProvenanceNodeSchema.optional()
        .nullish()
        .transform((v) => v ?? undefined),
});
//# sourceMappingURL=AbsoluteCharacteristicValueBase.js.map